import React from 'react';

export default function Ideas() {
  return (
    <article className="reading-page ideas-reading">
      <header className="personal-intro">
        <h1>Ideas</h1>
        <p className="personal-greeting">I'm rebuilding this page.</p>
      </header>
    </article>
  );
}
